import $ from 'jquery'
import 'sharer.js'

export default () => {

  let lastScrollTop = 0;
  $(window).scroll(function funcScoll() {
    const st = $(this).scrollTop();
    if (st > lastScrollTop) {
      $('.js-scroll-top').addClass('scroll-down');
    }
    if (st < lastScrollTop) {
      $('.js-scroll-top').removeClass('scroll-down');
    }
    if (lastScrollTop < 0) {
      $('.js-scroll-top').removeClass('scroll-down');
    }
    lastScrollTop = st;

    const heightWindow = 100;
    if ($(this).scrollTop() >= heightWindow) {
      $('.js-scroll-top').addClass('scroll');
    } else {
      $('.js-scroll-top').removeClass('scroll');
    }
  });



  $('.js-btn-down').on("click", function scrollToSectionFunc() {
    const scrollEl = $(this).attr('href');
    if ($(scrollEl).length !== 0) {
      $('html, body').animate({
        scrollTop: $(scrollEl).offset().top - 84
      }, 500);
    }
    return false;
  })

  $('.menu-item-has-children > a').on('click', function openDropDown() {
    if ($(window).width() < 1200) {
      $(this).parent('li').toggleClass('active')
      return false
    } return null 
  })

  $('.header__menu-btn').on('click', () => {
    $('.header__mobile').addClass('active')
  })

  $('.js-close-mobile').on('click', () => {
    $('.header__mobile').removeClass('active')
  })
  
  $('.js-search-btn').on('click', (event) => {
    event.stopPropagation();
    $('.header').toggleClass('active-search')
  })

  $(document).on("click", (event) => {
    event.stopPropagation();
    if ($(event.target).closest(".header__search-box").length) return;
    $('.header').removeClass('active-search')
  });

  $('.js-scroll-top').on('click', () => {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  });

  $('.text-content table').wrap('<div class="table-scroll"></div>')

  if ($('.js-sticky-btn').length) {
    $('.wrapper').addClass('wrapper--overflow-inherit')
  }

  $('.js-close-popup').on('click', () => {
    $('.js-popup').removeClass('active')
  })

}



// WEBPACK FOOTER //
// app/scripts/components/custom.js